import {Pipe, PipeTransform} from '@angular/core';

import { PlatformService } from "../../services/platform.service";

@Pipe({
    name: 'linkify'
})
export class LinkifyPipe implements PipeTransform  {

    constructor(
        public plt: PlatformService,
    ) {}

    public transform(value: string, target:string = '_system'): string {
        if (value) {
            //URLs starting with http://, https://, or ftp://
            let patternHttp = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/\(\)\{\}%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
            let replaceHttp = '<a href="$1" onclick="window.open(this.href, \'' + target + '\', \'noreferrer\');return false">$1</a>';

            //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
            let patternWww = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
            let replaceWww = '$1<a href="http://$2" onclick="window.open(this.href, \'' + target + '\', \'noreferrer\');return false">$2</a>';

            //local URLs will not have target blank
            let patternTarget = new RegExp('<a href="(.*)" [^>]*>(.*'+window.location.host+'.*)<\/a>');
            // let replaceTarget = '<a href="$1" onclick="window.open(this.href, \'' + target + '\');return false">$2</a>';
            let replaceTarget = '<a href="$1">$2</a>';

            // for cordova apps always use link to external page
            if (this.plt.is('cordova')) {
                replaceTarget = '<a href="$1" onclick="window.open(this.href, \'' + target + '\');return false">$2</a>';
            }

            value = value.replace(patternHttp, replaceHttp);
            value = value.replace(patternWww, replaceWww);
            value = value.replace(patternTarget, replaceTarget);
        }

        return value;
    }

}
